import { css } from "styled-components";

/** Breakpoints for the Top Movers strip's card grid. */
export const GRID_BREAKPOINT_LG = "1024px";
export const GRID_BREAKPOINT_SM = "768px";

/** Responsive 3 → 2 → 1 column grid for the Top Movers cards. */
export const responsiveThreeColumnGrid = css`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));

    @media (max-width: ${GRID_BREAKPOINT_LG}) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: ${GRID_BREAKPOINT_SM}) {
        grid-template-columns: 1fr;
    }
`;
